import { useQuery } from '@tanstack/react-query';
import {
  getBids, type BidFilters 
} from '../api';

export function useBids(filters?: BidFilters) {
  return useQuery({
    queryKey: ['bids', filters],
    queryFn: () => getBids(filters),
    staleTime: 30_000,
  });
}
